/**
 * Enum representing the possible options for arterial blood gas results.
 */
export enum ArterialBloodGasOptions {
    Yes = "Yes",
    No = "No",
    NotAvailable = "NotAvailable"
}
